import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { PresentMemoryTrackerMetaSchema } from '../models';

extendZodWithOpenApi(z);
const c = initContract();

export const apiMemoriesTrackers = c.router({
  getMemoryTrackerSessions: {
    method: 'GET',
    path: `/1.0/memories/trackers/sessions`,
    summary: 'Recent Memory Tracker sessions',
    description: 'Returns the most recent (unique) Memory Tracker sessions.',
    responses: {
      200: z.object({ sessions: z.array(PresentMemoryTrackerMetaSchema) }),
    },
  },
});
